var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6454 0.125C17.0423 0.125 18.3861 0.677083 19.3746 1.66771C20.3642 2.65625 20.9173 3.98958 20.9173 5.38542V13.6146C20.9173 16.5208 18.5527 18.875 15.6454 18.875H5.35482C2.44753 18.875 0.0839844 16.5208 0.0839844 13.6146V5.38542C0.0839844 2.47917 2.43711 0.125 5.35482 0.125H15.6454ZM17.3026 6.93733L17.386 6.854C17.6349 6.55192 17.6349 6.11442 17.3745 5.81233C17.2297 5.65713 17.0308 5.56233 16.8235 5.5415C16.6047 5.53004 16.3964 5.604 16.2391 5.74983L11.5422 9.49984C10.9381 10.0009 10.0724 10.0009 9.4589 9.49984L4.7714 5.74983C4.44744 5.51025 3.99952 5.5415 3.72973 5.82275C3.44848 6.104 3.41723 6.55192 3.65577 6.86442L3.79223 6.99983L8.53181 10.6978C9.11515 11.1561 9.82244 11.4061 10.5631 11.4061C11.3016 11.4061 12.0214 11.1561 12.6037 10.6978L17.3026 6.93733Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.8d20003e3b2ac23dbb3904fb38cbc423.svg";
export { ForwardRef as ReactComponent };